// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React from 'react'
import './PharmacyDropdownItem.scss'

export const PharmacyDropdownItem = ({
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  currentPharmacy,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  title,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  distance,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  description,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  isTheLastItem,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  isEmpty,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  onSelectPharmacy,
}) => {
  const onClickItem = () => {
    if (onSelectPharmacy) {
      onSelectPharmacy(currentPharmacy)
    }
  }

  return (
    <div
      role='presentation'
      className={`pharmacy-dropdown-item-main-wrapper${isEmpty ? 'pharmacy-dropdown-item-main-wrapper--empty' : ''}`}
      onClick={onClickItem}>
      <div className={`pharmacy-dropdown-item-header${isEmpty ? 'pharmacy-dropdown-item-header--empty' : ''}`}>
        <div className='pharmacy-dropdown-item-text pharmacy-dropdown-item-title'>{title}</div>
        {distance ?
          <div className='pharmacy-dropdown-item-text'>
            {distance.toFixed(1)}
            mi
          </div>
        : null}
      </div>
      {description ?
        <div className='pharmacy-dropdown-item-text'>{description}</div>
      : null}
      {!isTheLastItem && <div className='pharmacy-dropdown-item-separate-line' />}
    </div>
  )
}
